/** Clears guest fragment / capability secrets from sessionStorage (XSS / shared-tab hygiene). */
export function clearGuestSessionSecrets(): void {
  const prefixes = [
    'shareweb:infoFragment:',
    'shareweb:folderFragment:',
    'shareweb:sedrFragment:',
    'shareweb:infoReplyPriv:',
  ];

  const keysToRemove: string[] = [];
  for (let i = 0; i < sessionStorage.length; i += 1) {
    const key = sessionStorage.key(i);
    if (!key) continue;
    if (prefixes.some((prefix) => key.startsWith(prefix))) {
      keysToRemove.push(key);
    }
  }

  for (const key of keysToRemove) {
    sessionStorage.removeItem(key);
  }
}
